import { Box, styled } from '@mui/material';
import useDialog from 'hooks/useDialog';
import { CardContainer, CardIllustration, ThemeButton, ThemeTypography } from 'DesignSystem';
import React from 'react';
import { EBackgroundTypes, EIllustrationTypes } from 'DesignSystem/types/background.types';
import { EAvailableSizes } from 'DesignSystem/types/size.types';
import {
  getReadableCompanyStatus,
  getCompanyStatusColor,
} from 'FeatureModules/Partner/utils/partner.utils';
import {
  OpacityContainer,
  PartnerImage,
  Title,
} from '../PartnersTable/PartnersTableBody/PartnersTableBody.styles';
import unknownDocument from 'assets/img/icons/unknown-document.svg';
import { IBasePartnerCompany } from 'FeatureModules/Partner/types/partner.types';
import defaultPartnerImage from 'assets/img/partners/default-partner-image.png';

export const RequestIcon = styled('img')(() => ({
  width: 18,
  color: 'white',
}));

interface IProps {
  partner: IBasePartnerCompany;
  setSkipInviteStepCard: (skip: boolean) => void;
}

const PartnerInviteCard: React.FC<IProps> = ({ partner, setSkipInviteStepCard }) => {
  const { openDialog } = useDialog();

  return (
    <CardContainer
      title="Invite your partner to request their supply chain information directly"
      size={EAvailableSizes.LARGE}
      background={EBackgroundTypes.WORLD}
      data-testid="home-getting-started-block"
      renderIllustration={
        <CardIllustration image={EIllustrationTypes.LOCATIONS} width={260} right={0} top={0} />
      }
    >
      <Box>
        <Box pb={2} mt="auto">
          <CardContainer padding={1.5} maxWidth="550px">
            <OpacityContainer display="flex" is-transparent="false">
              <PartnerImage
                alt={`Logo of ${partner.name}`}
                src={partner.logo?.url || defaultPartnerImage}
              />
              <Box display="flex" flexDirection="column" justifyContent="center">
                <Title>{partner.name}</Title>

                <ThemeTypography
                  variant="ITEM_SUBTITLE"
                  color={getCompanyStatusColor(partner.status)}
                >
                  {getReadableCompanyStatus(partner.status)}
                </ThemeTypography>
              </Box>
            </OpacityContainer>
          </CardContainer>
        </Box>

        <Box display="flex">
          <ThemeButton
            color="PRIMARY"
            size="large"
            startIcon={<RequestIcon src={unknownDocument} />}
            onClick={() => {
              openDialog({
                type: 'ADD_EDIT_PARTNER',
                props: { partner, enableInvite: true },
              });
            }}
          >
            Invite partner
          </ThemeButton>
          <Box ml={2}>
            <ThemeButton
              color="BLUE_ICE"
              size="large"
              onClick={() => {
                setSkipInviteStepCard(true);
              }}
            >
              Skip for now
            </ThemeButton>
          </Box>
        </Box>
      </Box>
    </CardContainer>
  );
};

export default PartnerInviteCard;
